import React from 'react'
// components
import ReviewCard from 'components/Modals/PlanItems/components/ReviewsList/components/ReviewCard'
// context
import ReviewDetailsBL from 'containers/Review/ReviewDetails/layers/BL'

const ReviewCardContainer: React.FC<any> = props => {
  return (
    <ReviewDetailsBL {...props}>
      <ReviewCard />
    </ReviewDetailsBL>
  )
}
export default ReviewCardContainer
